import { rightsSchema } from './common';
import { z } from 'zod';
import { audienceSchema } from './object';

export const shareGeneralAccessRulesSchema = z.union([z.literal('link'), z.literal('invitation')]);
export type ShareGeneralAccessRules = z.infer<typeof shareGeneralAccessRulesSchema>;

export const shareOptionObjectSchema = z.object({
    id: z.number(),
    title: z.string(),
    uri: z.string(),
    idUser: z.number(),
    _right: rightsSchema,
});
export type ShareOptionObject = z.infer<typeof shareOptionObjectSchema>;

export const shareAccessPropsSchema = z.object({
    audience: z.array(audienceSchema),
    read: z.array(z.string()),
    write: z.array(z.string()),
});
export type ShareAccessProps = z.infer<typeof shareAccessPropsSchema>;

export const shareAccessObjectSchema = z.object({
    id: z.number(),
    type: z.string(),
    uri: z.string(),
    title: z.string(),
    generalAccessRule: shareGeneralAccessRulesSchema,
    generalAccessHash: z.string().nullable(),
    idUser: z.number(),
    _audience: z.array(audienceSchema),
    _right: rightsSchema,
});
export type ShareAccessObject = z.infer<typeof shareAccessObjectSchema>;
